/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErroResponse,
  SaldoDeCreditoResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCreditosControllerSaldoUrl = () => {




  return `/v1/creditos/saldo`
}

/**
 * @summary Quantas discussões o usuário ainda pode abrir sem cobrança
 */
export const creditosControllerSaldo = async ( options?: Parameters<typeof httpClient>[1]): Promise<SaldoDeCreditoResponse> => {

  return httpClient<SaldoDeCreditoResponse>(getCreditosControllerSaldoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCreditosControllerSaldoQueryKey = () => {
    return [
    `/v1/creditos/saldo`
    ] as const;
    }


export const getCreditosControllerSaldoQueryOptions = <TData = Awaited<ReturnType<typeof creditosControllerSaldo>>, TError = ErroResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditosControllerSaldo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditosControllerSaldoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditosControllerSaldo>>> = ({ signal }) => creditosControllerSaldo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditosControllerSaldo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CreditosControllerSaldoQueryResult = NonNullable<Awaited<ReturnType<typeof creditosControllerSaldo>>>
export type CreditosControllerSaldoQueryError = ErroResponse


export function useCreditosControllerSaldo<TData = Awaited<ReturnType<typeof creditosControllerSaldo>>, TError = ErroResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditosControllerSaldo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof creditosControllerSaldo>>,
          TError,
          Awaited<ReturnType<typeof creditosControllerSaldo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreditosControllerSaldo<TData = Awaited<ReturnType<typeof creditosControllerSaldo>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditosControllerSaldo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof creditosControllerSaldo>>,
          TError,
          Awaited<ReturnType<typeof creditosControllerSaldo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreditosControllerSaldo<TData = Awaited<ReturnType<typeof creditosControllerSaldo>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditosControllerSaldo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Quantas discussões o usuário ainda pode abrir sem cobrança
 */

export function useCreditosControllerSaldo<TData = Awaited<ReturnType<typeof creditosControllerSaldo>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditosControllerSaldo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCreditosControllerSaldoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






